import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=1d016eaf&scoped=true&"
import script from "./shop.vue?vue&type=script&lang=js&"
export * from "./shop.vue?vue&type=script&lang=js&"
import style0 from "./shop.vue?vue&type=style&index=0&id=1d016eaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d016eaf",
  null
  
)

export default component.exports